import { getTrades } from "./index"
import { chain, get, capitalize } from "lodash"
import { createSelector } from "reselect"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getCompositionReferenceEquity } from "modules/optimization/selectors/data"
import { getExcelValue } from "helpers/csv"

const TRADE_TYPES_ORDER = {
  buy: 1,
  sell: 2,
  short: 3,
  cover: 4,
}

const HEADERS = [
  "Trade Type",
  "Identifier",
  "MIC",
  "Bloomberg Ticker",
  "Country",
  "Asset Class",
  "Currency",
  "Industry",
  "Original Position Size",
  "Rebalanced Position Size",
  "Position $ Change",
  "Original Equity %",
  "Rebalanced Equity %",
  "Equity % Change",
]

const getDate = (state, props) => props.on
const getPortfolioGmv = state => get(state, "global.data.portfolioData.data.portfolio.dates.0.gmv")

const getEquityForExport = createSelector(
  [getCompositionReferenceEquity, getPortfolioGmv],
  (reference, gmv) => reference ?? gmv,
)

export const getFileName = createSelector(
  [getPortfolioName, getViewType, getDate],
  (portfolioName, viewType, date) => `${portfolioName} Optimizer Trades ${capitalize(viewType.slice(0, 3))} ${date}`,
)

export const getCsvRows = createSelector(
  [getTrades, getEquityForExport],
  (trades, equityForExport) => [
    HEADERS,
    ...chain(trades)
      .sortBy([({ tradeType }) => TRADE_TYPES_ORDER[tradeType], "ticker"])
      .map(({
        tradeType,
        ticker,
        mic,
        bloombergTicker,
        country,
        currency,
        classification,
        originalPercentEquity,
        percentEquity,
        rebalancedPercentEquity,
      }) => ([
        tradeType,
        ticker,
        mic,
        bloombergTicker,
        country,
        "equity",
        currency,
        get(classification, "name"),
        getExcelValue(originalPercentEquity * equityForExport),
        getExcelValue(rebalancedPercentEquity * equityForExport),
        getExcelValue((rebalancedPercentEquity - originalPercentEquity) * equityForExport),
        getExcelValue(originalPercentEquity, { percent: true }),
        getExcelValue(rebalancedPercentEquity, { percent: true }),
        getExcelValue(percentEquity, { percent: true }),
      ]))
      .value(),
  ])
